const Returns = React.lazy(() => import("../IncludeReturns"));
const IBBills = React.lazy(() => import("../IBBills"));
const Traps = React.lazy(() => import("../Traps"));
const PlanDate = React.lazy(() => import("../PlanDateForm"));

const StepContent = ({ step, enableTraps, ...props }) => {
  const componentByStep = {
    0: <PlanDate {...props} />,
    1: <Returns {...props} />,
    2: <IBBills {...props} />,
    3: enableTraps ? <Traps {...props} /> : undefined,
  };
  return componentByStep[step] || <span>Unknown step</span>;
};

export default StepContent;
